import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'

import { Typography } from '@material-ui/core'
import { Button, Checkbox } from 'ui/components'

import { getOrganization, putOrganization } from 'services/apiMotorBgc'
import reportError from 'utils/errorReporter'

export default function () {
  const apiKey = useSelector((state) => state.auth.api_key)
  const userId = useSelector((state) => state.auth.sub)
  const userOrgId = useSelector((state) => state.user.org_id)

  const [organization, setOrganization] = useState(null)

  const getAndSetOrg = async (options = {}) => {
    let res = null

    try {
      res = await getOrganization(
        apiKey,
        userId,
        {
          orgId: options.orgId,
        },
      )
    } catch (err) {
      reportError(err, 'Erro ao obter organização')
      return
    }

    setOrganization(res.data)
  }

  useEffect(() => {
    getAndSetOrg({ orgId: userOrgId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSave = async () => {
    try {
      await putOrganization(
        apiKey,
        userId,
        {
          orgId: userOrgId,
          orgData: organization,
        },
      )
    } catch (err) {
      reportError(err, 'Erro ao salvar')
      return
    }

    toast.success('Salvo com sucesso!')
  }

  const handleCheckUsePlan = (checked) => {
    const newOrg = _.cloneDeep(organization)
    newOrg.config.use_plan = checked
    setOrganization(newOrg)
  }

  const renderOrgName = (orgName) => {
    return (
      <Typography>
        <span>Nome:</span>
        {' '}
        <strong>{orgName}</strong>
      </Typography>
    )
  }

  const renderOrgUsePlan = (orgUsePlan) => {
    return (
      <Checkbox
        value={orgUsePlan}
        label="Usar o plano da organização"
        onClick={handleCheckUsePlan}
      />
    )
  }

  if (_.isEmpty(organization)) return null

  return (
    <div>
      {renderOrgName(organization.name)}
      <br />
      {renderOrgUsePlan(_.get(organization, 'config.use_plan'))}
      <br />

      <Button onClick={handleSave}>
        Salvar
      </Button>
    </div>
  )
}
